import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { bindActionCreators } from "redux";
import { userFarmDetail } from "../../../config/farmDetails";
import { harvestYearDetail } from "../../../config/harvestYearDetail";
import { createTruckAction } from "../../../modules/truckline/action";
import "../../../style";
import { validForm } from "../../FormElement/FormValidator";
import TrucklineForm from "./TrucklineForm";


class CreateTruckline extends Component {
  constructor(props) {
    super(props);

    this.state = {
      trucklineInfo: {
        farmId: userFarmDetail().id || props.MainFarmId,
        name: "",
        truckLineTypeId: "",
        contact: "",
        harvestYear: harvestYearDetail().name
      },
      formErrors: {
        name: "",
        truckLineTypeId: ""
      },
      isValid: true,
      successMessage: "",
      errorMessage: {},
      edited: false
    };
  }

  componentDidUpdate = () => {
    if (this.state.edited) {
      window.onbeforeunload = () => true;
    } else {
      window.onbeforeunload = undefined;
    }
  };

  componentWillUnmount() {
    window.onbeforeunload = undefined;
  }

  handleChange = event => {
    if (!this.state.edited) this.setState({ edited: true });
    const { name, value } = event.target;
    if (name === "contact") {
      if (value.match(/^\d{0,15}?$/)) {
        this.updateState(name, value);
      }
    } else if (name === "name") {
      if (value.match(/^(\w|\ ){0,51}$/)) {
        this.updateState(name, value);
      }
    } else if (name === "address" || name === "comment") {
      if (value.match(/^(.|\n){0,256}$/)) {
        this.updateState(name, value);
      }
    } else {
      this.updateState(name, value);
    }
  };

  updateState = (name, value) => {
    this.setState(
      prevState => {
        return {
          trucklineInfo: {
            ...prevState.trucklineInfo,
            [name]: value
          }
        };
      },
      () => {
        const { trucklineInfo } = this.state;
        this.setState({
          isValid: validForm(this.state.formErrors, trucklineInfo)
        });
      }
    );
  };

  handleError = (name, error) => {
    this.setState(
      prevState => {
        return {
          formErrors: {
            ...prevState.formErrors,
            [name]: error
          }
        };
      },
      () => {
        const { trucklineInfo } = this.state;
        this.setState({
          isValid: validForm(this.state.formErrors, trucklineInfo)
        });
      }
    );
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.truckCreated && nextProps.truckCreated.status === 200) {
      this.setState({ successMessage: true });
    }
  }

  createTruckline = e => {
    e.preventDefault();
    const { trucklineInfo, isValid } = this.state;
    trucklineInfo.farmId = userFarmDetail().id || this.props.MainFarmId;
    trucklineInfo.harvestYear = harvestYearDetail().name;

    //this.handleError(blanks[0], `${blanks[0]} is required`);
    this.setState({ isValid: true, edited: false });

    this.props.createTruckAction(trucklineInfo);
  };
  render() {
    const { successMessage, isValid, trucklineInfo, edited } = this.state;
    if (successMessage) {
      return <Redirect to="/farmsetup/trucklines" />;
    }
    return (
      <TrucklineForm
        formLabel="Set up your trucklines"
        buttonLabel="Add new truckline"
        trucklineInfo={trucklineInfo}
        handleChange={this.handleChange}
        handleError={this.handleError}
        createTruckline={this.createTruckline}
        isValid={isValid}
        edited={edited}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    truckCreated: state.trucklineReducer.truckCreated,
    MainFarmId: state.FarmManagementReducer.MainFarmId
  };
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ createTruckAction }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateTruckline);



// WEBPACK FOOTER //
// ./src/components/private/Trucklines/CreateTruckline.js